import { isMobile } from "./isMobile";

/*
 * Fixed position header
 * ----------------------------------------------- */
jQuery(window).on("load scroll", function () {
  var $anchor = jQuery("#concept");

  if (!$anchor.length) {
    return false;
  }

  var $jsHeader = jQuery(".navbar-simple");

  $jsHeader.each(function () {
    var scroll = jQuery(window).scrollTop();
    var formOffset = $anchor.offset().top;

    if (isMobile()) {
      formOffset = formOffset - 71;
    }

    if (scroll >= formOffset) {
      $jsHeader.addClass("navbar-white");
    } else {
      $jsHeader.removeClass("navbar-white");
    }
  });
});
